@if (formGroup()) {
    @if (isDialog()) {
        <div style="width: fit-content">
            <ng-container [ngTemplateOutlet]="form"></ng-container>
            <br />
            @if (!formBlueprint().noCancelConfirm) {
                <div class="dialog-actions">
                    <button mat-flat-button (click)="cancel.emit('close')">
                        Cancel
                    </button>
                    <button
                        mat-flat-button
                        (click)="onConfirm()"
                        [disabled]="!formGroup()?.valid || confirmDisabled()"
                    >
                        Confirm
                    </button>
                </div>
            }
        </div>
    } @else {
        <mat-card style="width: fit-content">
            <mat-card-header class="header">
                <mat-card-title>
                    {{ title() }}
                </mat-card-title>
                @if (!formBlueprint().noCancelConfirm) {
                    <div>
                        <button
                            mat-flat-button
                            (click)="onConfirm()"
                            [disabled]="
                                !formGroup()?.valid || confirmDisabled()
                            "
                        >
                            Confirm
                        </button>
                    </div>
                }
            </mat-card-header>
            <mat-divider></mat-divider>
            <br />
            <mat-card-content>
                <ng-container [ngTemplateOutlet]="form"></ng-container>
            </mat-card-content>
        </mat-card>
    }
}
<ng-template #form>
    @let group = formGroup();
    @if (group) {
        <form
            [style]="'max-height:' + formBlueprint().maxHeight"
            [formGroup]="group"
            class="inputForm"
        >
            @let fields = formBlueprint().fromFields;
            @for (formField of fields; track formField) {
                @let group = getGroup(formField);
                @if (group) {
                    <div class="group">
                        <mat-label>{{ group.caption }}</mat-label>
                        <mat-divider></mat-divider>
                        <br />
                        @for (
                            innerField of group.formFields;
                            track innerField
                        ) {
                            @if (getFieldInput(innerField)) {
                                <ng-container
                                    *ngTemplateOutlet="
                                        formfield;
                                        context: { $implicit: innerField }
                                    "
                                ></ng-container>
                            }
                        }
                        <mat-divider></mat-divider>
                        <br />
                    </div>
                } @else if (getFieldInput(formField)) {
                    <ng-container
                        *ngTemplateOutlet="
                            formfield;
                            context: { $implicit: formField }
                        "
                    ></ng-container>
                }
            }
            <ng-template #formfield let-formField>
                @switch (formField.input.type) {
                    @case ("textInput") {
                        <mat-form-field class="field">
                            <mat-label>{{
                                formField.input.placeholder
                            }}</mat-label>
                            <input
                                matInput
                                readonly="{{ formField.input.readonly }}"
                                placeholder="{{ formField.input.placeholder }}"
                                formControlName="{{ formField.field.key }}"
                            />
                            <mat-hint>{{ formField.input.hint }}</mat-hint>
                        </mat-form-field>
                    }
                    @case ("textAreaInput") {
                        <mat-form-field class="field">
                            <mat-label>{{
                                formField.input.placeholder
                            }}</mat-label>
                            @if (formField.input.autosize) {
                                <textarea
                                    matInput
                                    readonly="{{ formField.input.readonly }}"
                                    cdkTextareaAutosize
                                    [cdkAutosizeMinRows]="
                                        $safeNavigationMigration(
                                            formField.input.autosize?.min
                                        )
                                    "
                                    [cdkAutosizeMaxRows]="
                                        $safeNavigationMigration(
                                            formField.input.autosize?.max
                                        )
                                    "
                                    placeholder="{{
                                        formField.input.placeholder
                                    }}"
                                    formControlName="{{ formField.field.key }}"
                                >
                                </textarea>
                            } @else {
                                <textarea
                                    matInput
                                    readonly="{{ formField.input.readonly }}"
                                    placeholder="{{
                                        formField.input.placeholder
                                    }}"
                                    formControlName="{{ formField.field.key }}"
                                >
                                </textarea>
                            }
                            <mat-hint>{{ formField.input.hint }}</mat-hint>
                        </mat-form-field>
                    }
                    @case ("numberInput") {
                        <mat-form-field class="field">
                            <mat-label>{{
                                formField.input.placeholder
                            }}</mat-label>
                            <input
                                max="{{ formField.input.max }}"
                                min="{{ formField.input.min }}"
                                matInput
                                type="number"
                                readonly="{{ formField.input.readonly }}"
                                placeholder="{{ formField.input.placeholder }}"
                                formControlName="{{ formField.field.key }}"
                            />
                            <mat-hint>{{ formField.input.hint }}</mat-hint>
                        </mat-form-field>
                    }
                    @case ("dateTime") {
                        <mat-form-field class="field">
                            <mat-label>{{
                                formField.input.placeholder
                            }}</mat-label>
                            <input
                                matInput
                                formControlName="{{ formField.field.key }}"
                                [matDatepicker]="picker"
                            />
                            <mat-hint>{{ formField.input.hint }}</mat-hint>
                            <mat-datepicker-toggle
                                matIconSuffix
                                [for]="picker"
                            ></mat-datepicker-toggle>
                            <mat-datepicker #picker></mat-datepicker>
                        </mat-form-field>
                    }
                    @case ("slider") {
                        <mat-slide-toggle
                            class="field"
                            formControlName="{{ formField.field.key }}"
                            labelPosition="before"
                        >
                            {{ formField.input.placeholder }}
                        </mat-slide-toggle>
                    }
                    @case ("selection") {
                        <mat-form-field class="field">
                            <mat-label>{{
                                formField.input.placeholder
                            }}</mat-label>
                            <mat-select
                                placeholder="{{ formField.input.placeholder }}"
                                formControlName="{{ formField.field.key }}"
                            >
                                @for (
                                    selection of formField.input.selections(
                                        values()
                                    );
                                    track $index
                                ) {
                                    <mat-option [value]="selection.value">{{
                                        selection.name
                                    }}</mat-option>
                                }
                            </mat-select>
                            <mat-hint>{{ formField.input.hint }}</mat-hint>
                        </mat-form-field>
                    }
                    @case ("autocompleteTextAreaInput") {
                        <mat-form-field class="field">
                            <mat-label>{{
                                formField.input.placeholder
                            }}</mat-label>
                            <textarea
                                matInput
                                readonly="{{ formField.input.readonly }}"
                                placeholder="{{ formField.input.placeholder }}"
                                formControlName="{{ formField.field.key }}"
                                [matAutocomplete]="autoTextArea"
                            >
                            </textarea>
                            <mat-autocomplete #autoTextArea="matAutocomplete">
                                @for (
                                    option of formField.input.filteredSelections(
                                        formContext()
                                    );
                                    track option.value
                                ) {
                                    <mat-option [value]="option.value">{{
                                        option.name
                                    }}</mat-option>
                                }
                            </mat-autocomplete>
                        </mat-form-field>
                    }
                    @case ("autocompleteTextInput") {
                        <mat-form-field class="field">
                            <mat-label>{{
                                formField.input.placeholder
                            }}</mat-label>
                            <input
                                matInput
                                readonly="{{ formField.input.readonly }}"
                                placeholder="{{ formField.input.placeholder }}"
                                formControlName="{{ formField.field.key }}"
                                [matAutocomplete]="autoInput"
                            />
                            <mat-autocomplete
                                #autoInput="matAutocomplete"
                                [displayWith]="
                                    formField.input.displayValueFn.bind(this)
                                "
                            >
                                @for (
                                    option of formField.input.filteredSelections(
                                        formContext()
                                    );
                                    track option.value
                                ) {
                                    <mat-option [value]="option.value">{{
                                        option.name
                                    }}</mat-option>
                                }
                            </mat-autocomplete>
                        </mat-form-field>
                    }
                    @case ("checkbox") {
                        <mat-checkbox
                            class="field"
                            formControlName="{{ formField.field.key }}"
                        >
                            {{ formField.input.placeholder }}
                        </mat-checkbox>
                    }
                    @case ("list") {
                        <mat-label>{{ formField.input.placeholder }}</mat-label>
                        @for (
                            item of formField.input.list(values());
                            track $index
                        ) {
                            <mat-list
                                [matMenuTriggerFor]="
                                    item.itemActions ? actions : null
                                "
                                class="list-container"
                            >
                                @for (
                                    field of formField.input.itemSchema;
                                    track $index
                                ) {
                                    <mat-list-item class="list-item">
                                        <div class="list-item">
                                            <span
                                                matCardSubtitle
                                                style="font-size: small"
                                                >{{ field.label }}</span
                                            >
                                            <span>{{
                                                item.data[field.key]
                                            }}</span>
                                        </div>
                                    </mat-list-item>
                                }
                                <mat-menu xPosition="before" #actions="matMenu">
                                    @if (item.itemActions) {
                                        @for (
                                            action of item.itemActions();
                                            track $index
                                        ) {
                                            <button
                                                mat-menu-item
                                                (click)="
                                                    action.action(item.data)
                                                "
                                            >
                                                {{ action.name }}
                                            </button>
                                        }
                                    }
                                </mat-menu>
                            </mat-list>
                        }
                        @if (formField.input.addItem) {
                            <div class="list-add-button">
                                <button
                                    mat-flat-button
                                    (click)="
                                        formField.input.addItem(formField.input)
                                    "
                                >
                                    ADD
                                </button>
                            </div>
                        }
                    }
                    @default {
                        <p>SOMETHING IS WRONG</p>
                    }
                }
            </ng-template>
        </form>
    }
</ng-template>
